
define('ldsh!modules/form_editor/templates/preview_custom_recaptcha_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<script async custom-element="amp-recaptcha-input" src="https://cdn.ampproject.org/v0/amp-recaptcha-input-0.1.js"></script>\n\n<div class="ed-item-captcha">\n    <div id="' +
((__t = ( idName )) == null ? '' : __t) +
'" class="ed-captcha-block ed-google-recaptcha"></div>\n</div>\n\n<amp-recaptcha-input layout="nodisplay" name="recaptcha_token" data-sitekey="' +
((__t = ( siteKey )) == null ? '' : __t) +
'" data-action="recaptcha_action">\n</amp-recaptcha-input>\n';

}
return __p
};});

